import * as types from "./actions";
import APIUtil from "../config/APIUtil";
import UrlConstants from "../config/UrlConstants";
import { cryptoTokenDecode } from "./../components/Common/Common";
import * as code from "../config/Constants";

/**
 *
 * @desc List Documents by usertype API call
 */
export function listDocAction(transactionId, folderType) {
  var url = UrlConstants.docsUrl.replace("{transactionId}", transactionId);
  var type = "";
  let currentType = localStorage.getItem("currentRole");
  if (currentType == "VENDOR") {
    type = "&vendorId=" + localStorage.getItem("ID") + "&type=vendor";
  } else if (currentType == "BUYER") {
    type = "&type=homebuyer";
  } else if (currentType == "BUYERAGENT") {
    type = "&type=buyeragent";
  } else {
    type = "&type=acctowner";
  }

  url = url + "&folderType=" + folderType + type;
  return function (dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_DOCS,
          docs: response.data.data,
          totalDocs: response.data.total,
        });
        return response.data.data;
      } else {
        dispatch({
          type: types.GET_DOCS,
          docs: {},
        });
        return {};
      }
    });
  };
}

/**
 *
 * @desc add document api call
 */
export function addDocAction(data) {
  // console.log('addDocAction data: ', data);
  return function (dispatch) {
    return APIUtil.postMethod(UrlConstants.addDocUrl, data, true).then(
      (response) => {
        if (response._id !== "") {
          dispatch({
            type: types.ADD_DOC,
            isDocAdded: true,
          });
        } else {
          dispatch({
            type: types.ADD_DOC,
            isDocAdded: false,
          });
        }

        return response;
      }
    );
  };
}

export function publicAddDocAction(data) {
  return function (dispatch) {
    return APIUtil.postMethod(UrlConstants.publicAddDocUrl, data, false).then(
      (response) => {
        if (response._id !== "") {
          dispatch({
            type: types.ADD_DOC,
            isDocAdded: true,
          });
        } else {
          dispatch({
            type: types.ADD_DOC,
            isDocAdded: false,
          });
        }

        return response;
      }
    );
  };
}

/**
 *
 * @desc update document
 */
export function updateDocAction(data, id) {
  return function (dispatch) {
    return APIUtil.putMethod(
      UrlConstants.addDocUrl + "?id=" + id,
      data,
      true
    ).then((response) => {
      if (response._id !== "") {
        dispatch({
          type: types.UPDATE_DOC,
          isDocAdded: true,
        });
      } else {
        dispatch({
          type: types.UPDATE_DOC,
          isDocAdded: false,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc delete document from task section
 */
export function deleteDocFromTaskAction(data, id) {
  return function (dispatch) {
    return APIUtil.putMethod(
      UrlConstants.deleteDocumentFromTask + id,
      data,
      true
    ).then((response) => {
      if (response._id !== "") {
        dispatch({
          type: types.UPDATE_DOC,
          isDocAdded: true,
        });
      } else {
        dispatch({
          type: types.UPDATE_DOC,
          isDocAdded: false,
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - upload property image
 */
export function uploadDocumentAction(data, id, eventId, uploadedFiles) {
  // console.log('uploadDocumentAction data: ', data);
  // console.log('uploadDocumentAction id: ', id);
  // console.log('uploadDocumentAction uploadedFiles: ', uploadedFiles);
  var url = UrlConstants.uploadDocUrl.replace("{transactionId}", id);

  if (eventId !== undefined) {
    url = url + "&eventId=" + eventId;
  }

  return function (dispatch) {
    return APIUtil.postFormDataMethod(url, data, true, uploadedFiles).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.UPLOAD_DOC,
            uploadSuccess: true,
          });
        } else {
          dispatch({
            type: types.UPLOAD_DOC,
            uploadSuccess: false,
          });
        }
        return response;
      }
    );
  };
}

export function publicUploadDocumentAction(data, id, eventId, uploadedFiles) {
  var url = UrlConstants.publicUploadDocUrl.replace("{transactionId}", id);

  if (eventId !== undefined) {
    url = url + "&eventId=" + eventId;
  }

  return function (dispatch) {
    return APIUtil.postFormDataMethod(url, data, false, uploadedFiles).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.UPLOAD_DOC,
            uploadSuccess: true,
          });
        } else {
          dispatch({
            type: types.UPLOAD_DOC,
            uploadSuccess: false,
          });
        }
        return response;
      }
    );
  };
}
/**
 * @desc Transactions - send document notification
 */
export function documentNotificationAction(id, eventId) {
  var url = UrlConstants.sendDocumentNotification.replace(
    "{transactionId}",
    id
  );

  if (eventId !== undefined) {
    url = url + "&eventId=" + eventId;
  }

  return function (dispatch) {
    return APIUtil.postFormDataMethod(url, "", true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.SEND_NOTIFICATION,
          sendNotification: true,
        });
        return true;
      } else {
        dispatch({
          type: types.SEND_NOTIFICATION,
          sendNotification: false,
        });
        return false;
      }
    });
  };
}
/**
 *
 * @desc archive doc by Id
 */
export function archiveDocAction(id) {
  return function (dispatch) {
    return APIUtil.putMethod(
      UrlConstants.archiveDocumentUrl + id,
      {},
      true
    ).then((response) => {
      if (response._id !== "") {
        dispatch({
          type: types.ARCHIVE_DOC,
        });
      } else {
        dispatch({
          type: types.ARCHIVE_DOC,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc remove document api call
 */
export function removeDocAction(data) {
  return function (dispatch) {
    return APIUtil.postMethod(UrlConstants.removeFolderUrl, data, true).then(
      (response) => {
        if (response._id !== "") {
          dispatch({
            type: types.REMOVE_DOC,
            isDocAdded: true,
          });
        } else {
          dispatch({
            type: types.REMOVE_DOC,
            isDocAdded: false,
          });
        }
        return response;
      }
    );
  };
}

/**
 * @desc Document - get all folders list
 */
export function getFolderListAction(transactionId, folderName) {
  let url = UrlConstants.folderList;
  url = url.replace("{transactionId}", transactionId);
  url = url.replace("{folderName}", folderName);
  return function (dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.FOLDER_LIST,
          folderList: response.data,
        });
      } else {
        dispatch({
          type: types.FOLDER_LIST,
          folderList: {},
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc move document api call
 */
export function moveDocAction(data, documentId) {
  let url = UrlConstants.moveDocumentUrl;
  url = url.replace("{documentId}", documentId);
  return function (dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response._id !== "") {
        dispatch({
          type: types.MOVE_DOC,
          isDocMove: true,
        });
      } else {
        dispatch({
          type: types.MOVE_DOC,
          isDocMove: false,
        });
      }

      return response;
    });
  };
}

/**
 * @desc Document - get all folders list
 */
export function getFolderPermissionAction(transactionId, folderName) {
  let url = UrlConstants.folderPermission;
  url = url.replace("{transactionId}", transactionId);
  url = url.replace("{folderName}", folderName);
  return function (dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.FOLDER_PERMISSION,
          folderPermission: response.data,
        });
      } else {
        dispatch({
          type: types.FOLDER_PERMISSION,
          folderPermission: {},
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc set folder permission api call
 */
export function setFolderPermissionAction(data) {
  return function (dispatch) {
    return APIUtil.postMethod(
      UrlConstants.setFolderPermissionUrl,
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.SET_PERMISSION,
          isPermissionSet: true,
        });
      } else {
        dispatch({
          type: types.SET_PERMISSION,
          isPermissionSet: false,
        });
      }

      return response;
    });
  };
}

/**
 *
 * @desc remove document api call
 */
export function removeDocumentAction(docID) {
  return function (dispatch) {
    let url = UrlConstants.removeDocumentUrl + docID;
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_DOC,
          status: true,
        });
      } else {
        dispatch({
          type: types.DELETE_DOC,
          status: false,
        });
      }
      return response;
    });
  };
}

//-------------------------- User Personal Document apis ----------------

/**
 *
 * @desc User List Documents by usertype API call
 */
export function listUserDocAction(folderType, contactId, ownerId) {
  var url = UrlConstants.userDocsUrl;
  var type = "";
  let currentType = localStorage.getItem("currentRole");
  if (currentType === "VENDOR") {
    type = "&vendorId=" + localStorage.getItem("ID") + "&type=vendor";
  } else if (currentType === "BUYER") {
    type = "&type=homebuyer";
  } else if (currentType === "BUYERAGENT") {
    type = "&type=buyeragent";
  } else {
    type = "&type=acctowner";
  }

  url =
    url +
    "?folderType=" +
    folderType +
    type +
    "&contactId=" +
    contactId +
    "&ownerId=" +
    ownerId;
  return function (dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_DOCS,
          docs: response.data.data,
          totalDocs: response.data.total,
        });
        return response.data.data;
      } else {
        dispatch({
          type: types.GET_DOCS,
          docs: {},
        });
        return {};
      }
    });
  };
}

/**
 *
 * @desc add user document api call
 */
export function addUserDocAction(data) {
  return function (dispatch) {
    return APIUtil.postMethod(UrlConstants.addUserDocUrl, data, true).then(
      (response) => {
        if (response._id !== "") {
          dispatch({
            type: types.ADD_DOC,
            isDocAdded: true,
          });
        } else {
          dispatch({
            type: types.ADD_DOC,
            isDocAdded: false,
          });
        }

        return response;
      }
    );
  };
}

/**
 * @desc User - upload files
 */
export function uploadUserDocumentAction(
  data,
  eventId,
  uploadedFiles,
  contactId,
  ownerId
) {
  var url = UrlConstants.uploadUserDocUrl;

  url = url + "?contactId=" + contactId + "&ownerId=" + ownerId;

  if (eventId !== undefined) {
    url = url + "&eventId=" + eventId;
  }

  return function (dispatch) {
    return APIUtil.postFormDataMethod(url, data, true, uploadedFiles).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.UPLOAD_DOC,
            uploadSuccess: true,
          });
        } else {
          dispatch({
            type: types.UPLOAD_DOC,
            uploadSuccess: false,
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc remove document api call
 */
export function removeUserDocumentAction(docID, contactId, ownerId) {
  return function (dispatch) {
    let url =
      UrlConstants.removeUserDocumentUrl +
      docID +
      "&contactId=" +
      contactId +
      "&ownerId=" +
      ownerId;
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_DOC,
          status: true,
        });
      } else {
        dispatch({
          type: types.DELETE_DOC,
          status: false,
        });
      }
      return response;
    });
  };
}

/**
 * @desc Document - get all folders list
 */
export function getUserFolderListAction(folderName, contactId, ownerId) {
  let url = UrlConstants.userFolderList;
  url = url.replace("{folderName}", folderName);
  url = url + "&contactId=" + contactId + "&ownerId=" + ownerId;

  return function (dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.FOLDER_LIST,
          folderList: response.data,
        });
      } else {
        dispatch({
          type: types.FOLDER_LIST,
          folderList: {},
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc set folder permission api call
 */
export function setUserFolderPermissionAction(data) {
  return function (dispatch) {
    return APIUtil.postMethod(
      UrlConstants.setUserFolderPermissionUrl,
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.SET_PERMISSION,
          isPermissionSet: true,
        });
      } else {
        dispatch({
          type: types.SET_PERMISSION,
          isPermissionSet: false,
        });
      }

      return response;
    });
  };
}


/**
 *
 * @desc List Documents by usertype API call - listing with pagination
 */
export function paginateListDocAction(data) {
  var url = UrlConstants.docsPaginateUrl;
  let currentType = localStorage.getItem("currentRole");
  if (currentType === "VENDOR") {
    data.type = localStorage.getItem("ID");
    data.vendorId = "vendor";
  } else if (currentType === "BUYER") {
    data.type = "homebuyer";
  } else if (currentType === "BUYERAGENT") {
    data.type = "buyeragent";
  } else {
    data.type = "acctowner";
  }

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_DOCS,
          docs: response.data.data,
          totalDocs: response.data.total,
        });
        return response.data;
      } else {
        dispatch({
          type: types.GET_DOCS,
          docs: {},
        });
        return {};
      }
    });
  };
}

/**
 *
 * @desc List Documents by usertype API call - listing with pagination for user documents
 */
export function paginateListUserDocAction(data) {
  var url = UrlConstants.userDocsPaginateUrl;
  let currentType = localStorage.getItem("currentRole");
  if (currentType === "VENDOR") {
    data.type = localStorage.getItem("ID");
    data.vendorId = "vendor";
  } else if (currentType === "BUYER") {
    data.type = "homebuyer";
  } else if (currentType === "BUYERAGENT") {
    data.type = "buyeragent";
  } else {
    data.type = "acctowner";
  }

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_DOCS,
          docs: response.data.data,
          totalDocs: response.data.total,
        });
        return response.data;
      } else {
        dispatch({
          type: types.GET_DOCS,
          docs: {},
        });
        return {};
      }
    });
  };
}